export default __webpack_public_path__ + "static/media/map-marker.b9930b54.png";